import Vue from 'vue'
import App from './App.vue'
import router from './router'
import { ValidationProvider, extend, ValidationObserver} from 'vee-validate';
import { required, required_if, email } from 'vee-validate/dist/rules';
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueLodash from 'vue-lodash'
import lodash from 'lodash'
import Datepicker from 'vuejs-datepicker';
import VueMask from 'v-mask'
import Intersect from 'vue-intersect'
// import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import CountrySelect from '@/components/CountrySelect.vue'
import VueI18n from 'vue-i18n'
import en from './locales/en.json';
import it from './locales/it.json';
import es from './locales/es.json';

Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.use(VueLodash, { name: 'custom' , lodash: lodash })
Vue.use(VueAxios, axios)
Vue.use(VueMask);
Vue.component('ValidationProvider', ValidationProvider);
Vue.component('Datepicker', Datepicker);
Vue.component('intersect', Intersect);
Vue.component('ValidationObserver', ValidationObserver);
Vue.component('CountrySelect', CountrySelect);

extend('email', {
  ...email,
  message: 'Inserisci un\'email valida'
});

extend('required', {
  ...required,
  message: 'Il campo è richiesto'
});

extend('required_if', {
  ...required_if,
  message: 'Il campo è richiesto'
});

Vue.config.productionTip = false;

function getLocale() {
  const urlParams = new URLSearchParams(window.location.search);
  const lang = urlParams.get('lang');
  const supportedLanguages = ['it', 'en', 'es']; // Elenco delle lingue supportate

  if (supportedLanguages.includes(lang)) {
    return lang;
  } else {
    return 'it'; // Lingua predefinita
  }
}

Vue.use(VueI18n);

// Create VueI18n instance with options
const i18n = new VueI18n({
  locale: getLocale(),
  fallbackLocale: 'it', // set locale
  messages: {
    en,
    it,
    es
  }, // set locale messages
})



new Vue({
  i18n,
  router,
  render: h => h(App),
}).$mount('#app')
 